import React, { useState } from 'react';
import { CityInterface } from '../../api/citiesPage';
import CardSnippet from '../CardSnippet/CardSnippet';
import Image from 'next/image';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
const Link = dynamic(() => import('next/link'));
interface CityCard extends CityInterface {
  index: number;
}
interface CardProps {
  large: boolean;
}

const StyledDiv = styled.div<CardProps>`
  @media (min-width: 1500px) {
    width: ${props => (props.large ? '38%' : '29%')} !important;
  }
  width: 350px;
  @media (max-width: 752px) {
    width: 500px;
  }
  @media (max-width: 652px) {
    width: 100%;
  }
`;
const largerCardIndexes = [0, 4, 8, 9, 13, 17, 18, 22, 26, 27];
const CityCard = ({ city, index }: CityCard) => {
  const [largeCard] = useState<boolean>(() =>
    largerCardIndexes.includes(index) ? true : false
  );

  const [showSnippet, setShowSnippet] = useState(false);

  return (
    <>
      <StyledDiv
        large={largeCard}
        onMouseEnter={() => {
          if (!showSnippet) {
            setShowSnippet(true);
          }
        }}
        onMouseLeave={() => setShowSnippet(false)}
      >
        <div
          id="image_wrapper"
          className="w-[100%] h-[100%] relative !overflow-hidden rounded-2xl"
        >
          <Link
            href={`/${city?.slug}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src={city?.cardMedia[0]?.url}
              width={500}
              height={340}
              quality={100}
              alt={city?.cardMedia[0]?.alt}
              className="w-[100%] h-full max-h-[400px] aspect-square rounded-2xl hover:scale-105 ease-in-out duration-200"
            />
          </Link>
          <CardSnippet
            index={index}
            text={city.cardSnippet}
            name={city.name}
            showSnippet={showSnippet}
            setShowSnippet={setShowSnippet}
            slug={city.slug}
          />
        </div>
      </StyledDiv>
    </>
  );
};

export default CityCard;
